import styled from '@emotion/styled'

export const FieldsContainer = styled.div`
	display: block;

	${({ theme }) => theme.MQ.M} {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
`
